import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '../globals';
declare var $, unescape, escape, AmCharts: any;

@Component({
  selector: 'app-score-report',
  templateUrl: './score-report.component.html',
  styleUrls: ['./score-report.component.css']
})
export class ScoreReportComponent implements OnInit {
  FirstName;
  MaltiRater;
  rate1;
  rate2;
  rate3;
  rate4;
  rate5;
  rate6;
  rate7;
  rate8;
  rate9;
  Delivering;
  Receiving;
  user1Entity;
  user2Entity;
  user3Entity;
  mavg;

  constructor(public globals: Globals, private router: Router) { }

  ngOnInit() {
    this.rate1 = localStorage.getItem('rate1');
    if (this.rate1 > 0 || this.rate1 == 0) {
      this.globals.pageTitle = '- Feedback Score';
      this.FirstName = localStorage.getItem('FirstName');
      this.MaltiRater = localStorage.getItem('MaltiRater');
      this.rate2 = localStorage.getItem('rate2');
      this.rate3 = localStorage.getItem('rate3');
      this.rate4 = localStorage.getItem('rate4');
      this.rate5 = localStorage.getItem('rate5');
      this.rate6 = localStorage.getItem('rate6');
      this.rate7 = localStorage.getItem('rate7');
      this.rate8 = localStorage.getItem('rate8');
      this.rate9 = localStorage.getItem('rate9');
      this.Delivering = localStorage.getItem('Delivering');
      this.Receiving = localStorage.getItem('Receiving');

      this.Delivering = parseFloat(this.Delivering);
      this.Receiving = parseFloat(this.Receiving);
      this.rate1 = parseFloat(this.rate1);
      this.rate2 = parseFloat(this.rate2);
      this.rate3 = parseFloat(this.rate3);
      this.rate4 = parseFloat(this.rate4);
      this.rate5 = parseFloat(this.rate5);
      this.rate6 = parseFloat(this.rate6);
      this.rate7 = parseFloat(this.rate7);
      this.rate8 = parseFloat(this.rate8);
      this.rate9 = parseFloat(this.rate9);

      this.user1Entity = {};
      this.user1Entity.rate1 = (1);
      this.user1Entity.rate2 = (2);
      this.user1Entity.rate3 = (4);
      this.user1Entity.rate4 = (2);
      this.user1Entity.rate5 = (0);
      this.user1Entity.rate6 = (0);
      this.user1Entity.rate7 = (3);
      this.user1Entity.rate8 = (4);
      this.user1Entity.rate9 = (1);

      this.user2Entity = {};
      this.user2Entity.rate1 = (3);
      this.user2Entity.rate2 = (1);
      this.user2Entity.rate3 = (4);
      this.user2Entity.rate4 = (3);
      this.user2Entity.rate5 = (0);
      this.user2Entity.rate6 = (1);
      this.user2Entity.rate7 = (2);
      this.user2Entity.rate8 = (3);
      this.user2Entity.rate9 = (4);

      this.user3Entity = {};
      this.user3Entity.rate1 = (3);
      this.user3Entity.rate2 = (1);
      this.user3Entity.rate3 = (4);
      this.user3Entity.rate4 = (3);
      this.user3Entity.rate5 = (0);
      this.user3Entity.rate6 = (1);
      this.user3Entity.rate7 = (2);
      this.user3Entity.rate8 = (3);
      this.user3Entity.rate9 = (4);

      this.mavg = {};
      this.mavg.rate2 = ((+this.user1Entity.rate2 + +this.user2Entity.rate2 + +this.user3Entity.rate2) / 3).toFixed(1);
      this.mavg.rate3 = ((+this.user1Entity.rate3 + +this.user2Entity.rate3 + +this.user3Entity.rate3) / 3).toFixed(1);
      this.mavg.rate1 = ((+this.user1Entity.rate1 + +this.user2Entity.rate1 + +this.user3Entity.rate1) / 3).toFixed(1);
      this.mavg.rate4 = ((+this.user1Entity.rate4 + +this.user2Entity.rate4 + +this.user3Entity.rate4) / 3).toFixed(1);
      this.mavg.rate5 = ((+this.user1Entity.rate5 + +this.user2Entity.rate5 + +this.user3Entity.rate5) / 3).toFixed(1);
      this.mavg.rate6 = ((+this.user1Entity.rate6 + +this.user2Entity.rate6 + +this.user3Entity.rate6) / 3).toFixed(1);
      this.mavg.rate7 = ((+this.user1Entity.rate7 + +this.user2Entity.rate7 + +this.user3Entity.rate7) / 3).toFixed(1);
      this.mavg.rate8 = ((+this.user1Entity.rate8 + +this.user2Entity.rate8 + +this.user3Entity.rate8) / 3).toFixed(1);
      this.mavg.rate9 = ((+this.user1Entity.rate9 + +this.user2Entity.rate9 + +this.user3Entity.rate9) / 3).toFixed(1);
    } else {
      this.router.navigate(['/welcome']);
    }
    var currentYear = (new Date()).getFullYear();
    $("#footer_year").html(currentYear);
    //FEEDBACK_REPORT_CHART
    var chart = AmCharts.makeChart("feedbackreport_chart", {
      "type": "serial",
      "theme": "none",
      "precision": 2,
      "valueAxes": [{
        "id": "v1",
        "title": "Feedback Answer",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function (value) {
          return "$" + Math.round(value) + "M";
        }
      }],
      "graphs": [{
        "id": "g3",
        "valueAxis": "v1",
        "lineColor": "#e1ede9",
        "fillColors": "#e1ede9",
        "fillAlphas": 1,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br /><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        "lineColor": "#62cf73",
        "fillColors": "#62cf73",
        "fillAlphas": 1,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br /><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": "#FFFFFF",
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": "#20acd4",
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br /><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": "#FFFFFF",
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": "#e1ede9",
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br /><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartCursor": {
        "pan": true,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "title",
      "categoryAxis": {
        "dashLength": 1,
        "title": "Feedback Categories",
        "position": "bottom",
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "valueAlign": "left",
        "maxColumns": 4,
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "title": "Opportunistic Coaching",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "title": "Empathetic",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "title": "Progressive",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "title": "Active Communication",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "title": "Self Regulation",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "title": "Reactive",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "title": "Contingent",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "title": "Solicitation",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "title": "Evidential",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }]
    });
    //END FEEDBACK_REPORT_CHART
    checkCookie_eu();

    function checkCookie_eu() {

      var consent = getCookie_eu("cookies_consent");

      if (consent == null || consent == "" || consent == undefined) {
        // show notification bar
        $('#cookie_directive_container').show();
      }

    }

    function setCookie_eu(c_name, value, exdays) {

      var exdate = new Date();
      exdate.setDate(exdate.getDate() + exdays);
      var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
      document.cookie = c_name + "=" + c_value + "; path=/";

      $('#cookie_directive_container').hide();
    }


    function getCookie_eu(c_name) {
      var i, x, y, ARRcookies = document.cookie.split(";");
      for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
          return unescape(y);
        }
      }
    }


  }
  close_cookie() {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + 30);
    var c_value = escape(1) + ((30 == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = "cookies_consent =" + c_value + "; path=/";

    $('#cookie_directive_container').hide();
  }

}




// WEBPACK FOOTER //
// D:/xampp/htdocs/OESS_LFB_V2demo/src/app/score-report/score-report.component.ts